import { useSearch, useFreeTitles, useRanking } from '@!/Hooks'
import { useMemo } from 'react'

const authorNameToArray = (authorName) => (authorName ? authorName.split(',').map((name) => name.trim()) : [])

export function useAuthorTitlesSearch(currentBook) {
  const searchTerm = useMemo(() => {
    if (!currentBook) return null
    const names = authorNameToArray(currentBook.author_name)
    return names[0]
  }, [currentBook])

  const options = {
    exclude_title_ids: [currentBook?.title_id],
  }
  const fetchType = 'top'

  const { data } = useSearch('author', searchTerm, 1, options, fetchType)

  return { titles: data?.titles ?? [], searchTerm }
}

export function useMagazineTitlesSearch(currentBook) {
  const searchTerm = useMemo(() => currentBook?.magazine_name, [currentBook])

  const options = {
    exclude_title_ids: [currentBook?.title_id],
  }
  const fetchType = 'top'

  const { data } = useSearch('magazine', searchTerm, 1, options, fetchType)

  return { titles: data?.titles ?? [], searchTerm }
}

export function useFreeTitlesSearch(currentBook) {
  const genreTabName = useMemo(() => currentBook?.genre_tab_name, [currentBook])
  const page = 1
  const fetchType = 'top'
  const { data } = useFreeTitles(genreTabName, page, fetchType)

  const genreLabel = useMemo(() => {
    const genreLabels = {
      man: '少年・青年',
      woman: '少女・女性',
      tl: 'TL',
      bl: 'BL',
    }
    return genreLabels[genreTabName] ?? genreTabName
  }, [genreTabName])

  return {
    titles: data?.titles ?? [],
    genreLabel,
    url: genreTabName ? `/store/search/free/${genreTabName}` : '/store/search/free',
  }
}

export function useRankingTitlesSearch(currentBook) {
  const rankingType = useMemo(() => {
    if (!currentBook) return undefined
    // ランキングのスクロールコンテンツは特定のジャンルの場合のみ表示
    return ['boy', 'man', 'girl', 'lady'].includes(currentBook.ranking_type) ? currentBook.ranking_type : undefined
  }, [currentBook])
  const page = 1
  const fetchType = 'top'
  const { data } = useRanking(rankingType, page, fetchType)

  return {
    titles: data ?? [],
    url: rankingType ? `/store/rankings?ranking_type=${rankingType}` : '/store/rankings',
  }
}
